import React from "react";
import { Button,  Form, OverlayTrigger, Popover, Table} from "react-bootstrap";
import {v4 as uuidv4} from "uuid";

export function PersonDisplay({person}){

    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h6">{person.name}</Popover.Header>
            <Popover.Body>
                <div>Telefon: {person.tel_1}, {person.tel_2}</div>
                <div>Pozycja: {person.position}</div>
                <div>Email: {person.email}</div>
            </Popover.Body>
        </Popover>
    );

    return (
        <>
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <div className={"person"}>{person.name}</div>
            </OverlayTrigger>
        </>
    )
}

export function PersonTable(props){
    const persons = props.persons;

    const handleOnChange = (persons)=>{

        if(props.onChange)
            props.onChange(persons);

    }

    const handleDeletePerson = (id)=>{
        const changedValue = persons.filter(p=>p.id !== id);
        handleOnChange(changedValue)
    }

    const handleAddPerson = ()=>{
        const changedValue = [
            ...persons, {id:uuidv4(), name:"", email:"", tel_1:"", tel_2:"", position:"", default_contact:0}
        ];
        handleOnChange(changedValue);
    }

    const onChangeDefaultContact = (id)=>{
        persons.forEach(p=>p.default_contact = p.id === id);
        handleOnChange(persons);
    }

    const handlePersonChanges = (id, event)=>{
        const key = event.target.name;
        const value = event.target.value;
        persons.forEach(p=> {
            if (p.id === id) p[key] = value
        })

        handleOnChange(persons);
    }

    return (
        <div className={"w-100 mt-1"}>

            <Table size={"sm"} striped bordered hover>
            <thead>
            <tr>
                <th>Domyślny kontakt</th>
                <th>Imię i nazwisko</th>
                <th>Email</th>
                <th>Telefon kontaktowy</th>
                <th>Dodatkowe numery</th>
                <th>Stanowisko</th>
                <th>Usuń</th>
            </tr>
            </thead>
            <tbody>
            {
                persons && persons.map((person) => {
                    return (
                        <tr key={person.id}>
                            <td>
                                <Form.Check type={"radio"} >
                                    <Form.Check.Input defaultChecked={person.default_contact === 1}  name={"person_default_contact"} type={"radio"} onChange={()=>onChangeDefaultContact(person.id)} />
                                </Form.Check>
                            </td>
                            <td><Form.Control size={"sm"} className={"personTableInput"} name={"name"} type="text" defaultValue={person.name} onChange={(event)=>handlePersonChanges(person.id, event)} /></td>
                            <td><Form.Control size={"sm"} className={"personTableInput"} name={"email"} type="text" defaultValue={person.email} onChange={(event)=>handlePersonChanges(person.id, event)} /></td>
                            <td><Form.Control size={"sm"} className={"personTableInput"} name={"tel_1"} type="text" defaultValue={person.tel_1} onChange={(event)=>handlePersonChanges(person.id, event)} /></td>
                            <td><Form.Control size={"sm"} className={"personTableInput"} name={"tel_2"} type="text" defaultValue={person.tel_2} onChange={(event)=>handlePersonChanges(person.id, event)} /></td>
                            <td><Form.Control size={"sm"} className={"personTableInput"} name={"position"} type="text" defaultValue={person.position} onChange={(event)=>handlePersonChanges(person.id, event)} /></td>
                            <td>
                                <span
                                    className={"fs-5 close-btn"}
                                    onClick={() => {handleDeletePerson(person.id)}}
                                    aria-hidden={"true"}>
                                    &times;
                                </span>
                            </td>
                        </tr>
                    )
                })
            }
            </tbody>
        </Table>
            <Button className={"float-end"} onClick={handleAddPerson} variant={"secondary"} >+</Button>
        </div>
    )
}
